'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

require('./ActionsRow.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta řádku detailu, který má akce, může obsahovat i celý obsah panelu, nebo být použit např. na část s akcemi nebo nadpis s akcemi.
 */
// -
var ActionsRow = function (_AbstractReactCompone) {
    (0, _inherits3.default)(ActionsRow, _AbstractReactCompone);

    function ActionsRow() {
        (0, _classCallCheck3.default)(this, ActionsRow);
        return (0, _possibleConstructorReturn3.default)(this, (ActionsRow.__proto__ || (0, _getPrototypeOf2.default)(ActionsRow)).apply(this, arguments));
    }

    (0, _createClass3.default)(ActionsRow, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                visibleActions = _props.visibleActions,
                noCenter = _props.noCenter,
                actions = _props.actions,
                children = _props.children,
                className = _props.className,
                other = (0, _objectWithoutProperties3.default)(_props, ['visibleActions', 'noCenter', 'actions', 'children', 'className']);


            var wrapperClassNames = (0, _classnames2.default)(className, "action-row-container", {
                "center-items": !noCenter,
                "actions-visible": visibleActions,
                "actions-hover": !visibleActions
            });

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: wrapperClassNames }, other),
                _react2.default.createElement(
                    'div',
                    { className: 'action-row-label' },
                    children
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'action-row-actions' },
                    actions
                )
            );
        }
        // TODO [R: dokumentace]

    }]);
    return ActionsRow;
}(_AbstractReactComponent2.default);

ActionsRow.propTypes = {
    // actions:   // akce
    // children: label
    // noCenter - pokud je true, centruji se obsay vertikalne
    // visibleActions - pokud je true, jsou akce vidět vždy, jinak pouze na hover
};
exports.default = ActionsRow;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZGV0YWlsL0FjdGlvbnNSb3cuanN4Il0sIm5hbWVzIjpbIkFjdGlvbnNSb3ciLCJwcm9wcyIsInZpc2libGVBY3Rpb25zIiwibm9DZW50ZXIiLCJhY3Rpb25zIiwiY2hpbGRyZW4iLCJjbGFzc05hbWUiLCJvdGhlciIsIndyYXBwZXJDbGFzc05hbWVzIiwiQWJzdHJhY3RSZWFjdENvbXBvbmVudCIsInByb3BUeXBlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUVBOzs7O0FBRUE7OztBQVBBO0lBVU1BLFU7Ozs7Ozs7Ozs7aUNBU087QUFBQSx5QkFDc0UsS0FBS0MsS0FEM0U7QUFBQSxnQkFDRUMsY0FERixVQUNFQSxjQURGO0FBQUEsZ0JBQ2tCQyxRQURsQixVQUNrQkEsUUFEbEI7QUFBQSxnQkFDNEJDLE9BRDVCLFVBQzRCQSxPQUQ1QjtBQUFBLGdCQUNxQ0MsUUFEckMsVUFDcUNBLFFBRHJDO0FBQUEsZ0JBQytDQyxTQUQvQyxVQUMrQ0EsU0FEL0M7QUFBQSxnQkFDNkRDLEtBRDdEOzs7QUFHTCxnQkFBTUMsb0JBQW9CLDBCQUN0QkYsU0FEc0IsRUFFdEIsc0JBRnNCLEVBR3RCO0FBQ0ksZ0NBQWdCLENBQUNILFFBRHJCO0FBRUksbUNBQW1CRCxjQUZ2QjtBQUdJLGlDQUFpQixDQUFDQTtBQUh0QixhQUhzQixDQUExQjs7QUFVQSxtQkFBTztBQUFBO0FBQUEseUNBQUssV0FBV00saUJBQWhCLElBQXVDRCxLQUF2QztBQUNIO0FBQUE7QUFBQSxzQkFBSyxXQUFVLGtCQUFmO0FBQW1DRjtBQUFuQyxpQkFERztBQUVIO0FBQUE7QUFBQSxzQkFBSyxXQUFVLG9CQUFmO0FBQXFDRDtBQUFyQztBQUZHLGFBQVA7QUFJSDtBQXpCRDs7OztFQURxQkssZ0M7O0FBQW5CVCxVLENBRUtVLFMsR0FBWTtBQUNmO0FBQ0E7QUFDQTtBQUNBO0FBSmUsQztrQkEyQlJWLFUiLCJmaWxlIjoiQWN0aW9uc1Jvdy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIC1cbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgY2xhc3NOYW1lcyBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCBBYnN0cmFjdFJlYWN0Q29tcG9uZW50IGZyb20gXCIuLi9BYnN0cmFjdFJlYWN0Q29tcG9uZW50XCI7XG5cbmltcG9ydCBcIi4vQWN0aW9uc1Jvdy5zY3NzXCI7XG5cbi8qKlxuICogS29tcG9uZW50YSDFmcOhZGt1IGRldGFpbHUsIGt0ZXLDvSBtw6EgYWtjZSwgbcWvxb5lIG9ic2Fob3ZhdCBpIGNlbMO9IG9ic2FoIHBhbmVsdSwgbmVibyBiw710IHBvdcW+aXQgbmFwxZkuIG5hIMSNw6FzdCBzIGFrY2VtaSBuZWJvIG5hZHBpcyBzIGFrY2VtaS5cbiAqL1xuY2xhc3MgQWN0aW9uc1JvdyBleHRlbmRzIEFic3RyYWN0UmVhY3RDb21wb25lbnQge1xuICAgIC8vIFRPRE8gW1I6IGRva3VtZW50YWNlXVxuICAgIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgICAgIC8vIGFjdGlvbnM6ICAgLy8gYWtjZVxuICAgICAgICAvLyBjaGlsZHJlbjogbGFiZWxcbiAgICAgICAgLy8gbm9DZW50ZXIgLSBwb2t1ZCBqZSB0cnVlLCBjZW50cnVqaSBzZSBvYnNheSB2ZXJ0aWthbG5lXG4gICAgICAgIC8vIHZpc2libGVBY3Rpb25zIC0gcG9rdWQgamUgdHJ1ZSwganNvdSBha2NlIHZpZMSbdCB2xb5keSwgamluYWsgcG91emUgbmEgaG92ZXJcbiAgICB9O1xuXG4gICAgcmVuZGVyKCkge1xuICAgICAgICBjb25zdCB7dmlzaWJsZUFjdGlvbnMsIG5vQ2VudGVyLCBhY3Rpb25zLCBjaGlsZHJlbiwgY2xhc3NOYW1lLCAuLi5vdGhlcn0gPSB0aGlzLnByb3BzO1xuXG4gICAgICAgIGNvbnN0IHdyYXBwZXJDbGFzc05hbWVzID0gY2xhc3NOYW1lcyhcbiAgICAgICAgICAgIGNsYXNzTmFtZSxcbiAgICAgICAgICAgIFwiYWN0aW9uLXJvdy1jb250YWluZXJcIixcbiAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgICBcImNlbnRlci1pdGVtc1wiOiAhbm9DZW50ZXIsXG4gICAgICAgICAgICAgICAgXCJhY3Rpb25zLXZpc2libGVcIjogdmlzaWJsZUFjdGlvbnMsXG4gICAgICAgICAgICAgICAgXCJhY3Rpb25zLWhvdmVyXCI6ICF2aXNpYmxlQWN0aW9uc1xuICAgICAgICAgICAgfVxuICAgICAgICApO1xuXG4gICAgICAgIHJldHVybiA8ZGl2IGNsYXNzTmFtZT17d3JhcHBlckNsYXNzTmFtZXN9IHsuLi5vdGhlcn0+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImFjdGlvbi1yb3ctbGFiZWxcIj57Y2hpbGRyZW59PC9kaXY+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImFjdGlvbi1yb3ctYWN0aW9uc1wiPnthY3Rpb25zfTwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IEFjdGlvbnNSb3c7XG4iXX0=